import React from 'react';
import User from '../../models/user';
import { tryFormatDate, DateFormats } from '../../utils/date-utils';

interface CustomProps {
  user: any;
  course:any
  eysightCheck?:boolean
}

const GeneralInformation: React.SFC<CustomProps> = (props: CustomProps) => {
  const renderHeader = () => {
    return <h6 className="pb-4 mt-md-3 text-primary">Student Information</h6>;
  };

  const renderName = () => {
    return (
      <div className="col-md-6 col-12 pb-md-1 mb-3">
        <div className="row justify-content-between">
          <div className="col-auto">
            <span className="label text-muted">Name</span>
          </div>
          <div className="col-auto text-right">
            <span className="font-small ">
              {props.user.name || ''}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const rendeReg = () => {
    return (
      <div className="col-md-6 col-12 pb-md-1 mb-3">
        <div className="row justify-content-between">
          <div className="col-auto">
            <span className="text-muted pl-xl-4 pl-lg-3">Reg.No</span>
          </div>
          <div className="col-auto text-right">
            <span className="font-small">
              {props.user.studentEdc}
              {/* {tryFormatDate(props.user.dob, DateFormats.MonthNameFormat)} */}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const renderNationality = () => {
    return (
      <div className="col-md-6 col-12 pb-md-1 mb-3">
        <div className="row justify-content-between">
          <div className="col-auto">
            <span className="text-muted pl-xl-4 pl-lg-3">Nationality</span>
          </div>
          <div className="col-auto text-right">
            <span className="font-small">{props.user.nationality || ''}</span>
          </div>
        </div>
      </div>
    );
  };

  const renderGender = () => {
    return (
      <div className="col-md-6 col-12 pb-md-1 mb-3">
        <div className="row justify-content-between">
          <div className="col-auto">
            <span className="label text-muted">Gender</span>
          </div>
          <div className="col-auto text-right">
            <span className="font-small pr-xl-4 pr-lg-3">
              {props.user.gender
                ? props.user.gender.charAt(0).toUpperCase() +
                  props.user.gender.substr(1)
                : ''}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const renderRequiredLicenseCategory = () => {
    return (
      <div className="col-md-6 col-12 pb-md-1 mb-3">
        <div className="row justify-content-between">
          <div className="col-auto">
            <span className="label text-muted">Required License Type</span>
          </div>
          <div className="col-auto text-right">
            <span className="font-small pr-xl-4 pr-lg-3">
              {'Light Motor Vehicle'}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const renderMobile = () => {
    return (
      <div className="col-md-6 col-12 pb-md-1 mb-3">
        <div className="row justify-content-between">
          <div className="col-auto">
            <span className="label text-muted">Mobile</span>
          </div>
          <div className="col-auto text-right">
            <span className="font-small pr-xl-4 pr-lg-3">
              {props.user 
                ? props.user.mobile
                : ''}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const renderCourseName = () => {
    return (
      <div className="col-md-6 col-12 pb-md-1 mb-3">
        <div className="row justify-content-between">
          <div className="col-auto">
            <span className="text-muted pl-xl-4 pl-lg-3">Course Name</span>
          </div>
          <div className="col-auto text-right">
            <span className="font-small">
              {props.course
                ? props.course.name
                : ''}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const renderDrivingLicenseNumber = () => {
    return props.user &&
      props.user.licenseDetails ? (
      <div className="col-md-6 col-12 pb-md-1 mb-3">
        <div className="row justify-content-between">
          <div className="col-auto">
            <span className="label text-muted">
              Driving License No
            </span>
          </div>
          <div className="col-auto text-right">
            <span className="font-small pr-xl-4 pr-lg-3">
              {props.user && props.user.licenseDetails && props.user.licenseDetails[0]?.licenseNumber
                ?  props.user.licenseDetails[0]?.licenseNumber
                : 'xxxxxxxx'}
            </span>
          </div>
        </div>
      </div>
    ) : (
      <></>
    );
  };

    const renderDrivingLicenseIssuerPlace = () => {
    return props.user &&
      props.user.licenseDetails ? (
      <div className="col-md-6 col-12 pb-md-1 mb-3">
        <div className="row justify-content-between">
          <div className="col-auto">
            <span className="label text-muted">
              Place of Issue
            </span>
          </div>
          <div className="col-auto text-right">
            <span className="font-small pr-xl-4 pr-lg-3">
              {props.user && props.user.licenseDetails
                ?  props.user.licenseDetails[0].licenseEmirate
                : ''}
            </span>
          </div>
        </div>
      </div>
    ) : (
      <></>
    );
  };

  const renderDate = () => {
    return props.user &&
      props.user.licenseDetails  ? (
      <div className="col-md-6 col-12 pb-md-1 mb-3">
        <div className="row justify-content-between">
          <div className="col-auto">
            <span className="text-muted pl-xl-4 pl-lg-3">IssueDate / Expiry Date</span>
          </div>
          <div className="col-auto text-right">
            <span className="font-small">
              {tryFormatDate(
                  props.user.licenseDetails[0].licenseIssueDate,
                DateFormats.MonthNameFormat
              )}
              {props.user.licenseDetails[0].licenseExpiryDate
                ? ' /  ' +
                  tryFormatDate(
                  props.user.licenseDetails[0].licenseExpiryDate,
                    DateFormats.MonthNameFormat
                  )
                : ''}
            </span>
          </div>
        </div>
      </div>
    ) : (
      <></>
    );
  };

  const renderCompany = () => {
    return (
      props.user &&
      props.user.companyDetails  ? (
      <div className="col-md-6 col-12 pb-md-1 mb-3">
        <div className="row justify-content-between">
          <div className="col-auto">
            <span className="text-muted pl-xl-4 pl-lg-3">Company Name</span>
          </div>
          <div className="col-auto text-right">
            <span className="font-small">
              {props.user && props.user.companyDetails
                ? props.user.companyDetails.name.en
                : ''}
            </span>
          </div>
        </div>
      </div>
      ):(<></>)
    );
  };

   const eyeSightCheck = () => {
    return (

      <div className="col-md-6 col-12 pb-md-1 mb-3">
        <div className="row justify-content-between">
          <div className="col-auto">
            <span className="text-muted pl-xl-4 pl-lg-3">Eyesight Check</span>
          </div>
          <div className="col-auto text-right">
            <span className="font-small">
              {props.eysightCheck 
                ? "Yes"
                : 'No'}
            </span>
          </div>
        </div>
      </div>

    );
  };

  return (
    <div className="bg-white rounded white-box px-md-4 px-3 py-4 mb-4" style={{border:"1px solid #ddd",boxShadow:"0px 10px 13px -7px #ddd, 5px 4px 13px 1px rgba(221,221,221,0) !important"}}>
      {renderHeader()}
      {props.user && (
        <div className="row mb-md-3">
          {renderName()}
          {rendeReg()}
          {renderGender()}
          {renderNationality()}
          {renderRequiredLicenseCategory()}
          {renderCourseName()}
          {renderMobile()}
          {renderCompany()}
          {renderDrivingLicenseNumber()}
          {renderDate()}
          {renderDrivingLicenseIssuerPlace()}
          {eyeSightCheck()}
        </div>
      )}
    </div>
  );
};

export default GeneralInformation;
